import React, { Fragment, useEffect, useState } from "react";
import "./style.scss";
import Tier from "..";
import TierHeader from "../TierHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  getPlans,
  getPlatform,
} from "../../../utils/store/reducers/accountMetricsSlice";
import LoaderOverlay from "../../../reusableComponents/LoaderOverlay/Index";
import Tabination from "../../../reusableComponents/Tabs";

function Plans() {
  const dispatch = useDispatch();
  const [activeTier, setActiveTier] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const planData = useSelector((state) => state.accountMetrics.plans);
  const { idToken } = useSelector((state) => state.auth);

  const plans = planData?.data || {};
  const challenges = plans;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(getPlans()),
          dispatch(getPlatform({ idToken })),
        ]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [dispatch, idToken]);

  const items = challenges.map((item) => ({
    name: item?.name,
  }));

  return (
    <div className="plans-container">
      {isLoading && <LoaderOverlay />}
      <Tabination
        variant={1}
        tabItems={items}
        showTabs={true}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      {challenges.length > 0 && (
        <div className="plans-subcontainer">
          <TierHeader tier={challenges[activeTab]} />
          <div className="plans-plan-container">
            {challenges.map(
              (item, index) =>
                index === activeTab && (
                  <Fragment key={index}>
                    <Tier
                      tiers={item}
                      activeTier={activeTier}
                      setActiveTier={setActiveTier}
                    />
                  </Fragment>
                )
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Plans;
